import { Navigate } from "react-router-dom";

import { ClimateActionLayout } from "./climate-actions/:climateActionId/climate-action.layout";
import { ClimateActionPage } from "./climate-actions/:climateActionId/climate-action.page";
import { ClimateActionActivityTabPage } from "./climate-actions/:climateActionId/climate-action-activity-tab.page";
import { ClimateActionDetailTabPage } from "./climate-actions/:climateActionId/climate-action-detail-tab.page";
import { ClimateActionDocumentsTabPage } from "./climate-actions/:climateActionId/climate-action-documents-tab.page";
import { ClimateActionListAllPage } from "./climate-actions/(list)/climate-action-list.all.page";
import { ClimateActionListDashboardPage } from "./climate-actions/(list)/climate-action-list.dashboard.page";
import { ClimateActionListLayout } from "./climate-actions/(list)/climate-action-list.layout";
import { ClimateActionListRootLayout } from "./climate-actions/climate-action-list-root.layout";
import { MyClimateActionListLayout } from "./my-climate-actions/my-climate-actions.layout";
import { MyClimateActionsPage } from "./my-climate-actions/my-climate-actions.page";

export const myClimateActionRoutes = [
  {
    path: "my-climate-actions",
    element: <MyClimateActionListLayout />,
    children: [{ path: "", element: <MyClimateActionsPage /> }],
  },
];

export const climateActionRoutes = [
  {
    path: "climate-actions",
    element: <ClimateActionListRootLayout />, // data loading for currentClimateActionList context
    children: [
      {
        path: "",
        element: <ClimateActionListLayout />, // shared header with tabs
        children: [
          { path: "", element: <Navigate to="all" replace /> },
          { path: "all", element: <ClimateActionListAllPage /> },
          { path: "dashboard", element: <ClimateActionListDashboardPage /> },
        ],
      },
      {
        path: ":climateActionId",
        element: <ClimateActionLayout />,
        children: [
          {
            path: "",
            element: <ClimateActionPage />,
            children: [
              { path: "", element: <Navigate to="details" replace /> },
              { path: "details", element: <ClimateActionDetailTabPage /> },
              { path: "activity", element: <ClimateActionActivityTabPage /> },
              { path: "documents", element: <ClimateActionDocumentsTabPage /> },
            ],
          },
        ],
      },
    ],
  },
];
